import React from 'react';
import { inject } from 'mobx-react';
import Link from 'core/components/Link';

const BgpCommunityLink = ({ $app, bgpCommunity, ...rest }) => {
  if ($app.isSubtenant) {
    return bgpCommunity;
  }
  return (
    <Link to={`/v4/core/quick-views/bgpCommunity/${bgpCommunity}`} {...rest}>
      {bgpCommunity}
    </Link>
  );
};

export default inject('$app')(BgpCommunityLink);
